import { useState, useEffect } from 'react';
import axios from 'axios';
import Jsona from 'jsona';

type TJsonaModel = Record<string, unknown>;

const dataFormatter = new Jsona();

type PageMeta = {
  total: number | null;
  perPage: number | null;
  currentPage: number | null;
  lastPage: number | null;
  firstPage: number | null;
};

export function useDirectoryList(params) {
  const [state, setState] = useState<{
    loading: boolean;
    error: string | null;
  }>({ loading: true, error: null });
  const [directoryList, setDirectoryList] = useState<
    TJsonaModel | TJsonaModel[]
  >([]);
  const [pageMeta, setPageMeta] = useState<PageMeta>({
    total: null,
    perPage: null,
    currentPage: null,
    lastPage: null,
    firstPage: null,
  });

  useEffect(() => {
    let pagingString = `page[number]=${params.page}&page[size]=${params.size}`;
    if (params.name) {
      pagingString += `&filter[name]=${params.name}`;
    }
    if (params.beginsWith) {
      pagingString += `&filter[beginsWith]=${params.beginsWith}`;
    }
    const fetchDirectoryList = async () => {
      try {
        setState({ loading: true, error: null });
        const response = await axios.get(
          process.env.REACT_APP_VIDEO_DIRECTORY +
            'api/v1/directory?' +
            pagingString
        );
        const normalizedData = dataFormatter.deserialize(response.data);
        setDirectoryList(normalizedData);
        setPageMeta({
          total: response.data.meta.total,
          perPage: response.data.meta.perPage,
          currentPage: response.data.meta.currentPage,
          lastPage: response.data.meta.lastPage,
          firstPage: response.data.meta.firstPage,
        });
        setState({ loading: false, error: null });
      } catch (error) {
        console.error('Error fetching directory list:', error);
        if (axios.isAxiosError(error)) {
          setState({ loading: false, error: error.message });
          setPageMeta({
            total: 0,
            perPage: 0,
            currentPage: 0,
            lastPage: 0,
            firstPage: 0,
          });
        } else {
          setState({ loading: false, error: 'An unexpected error occurred' });
        }
      }
    };

    fetchDirectoryList();
  }, [params.page, params.size, params.name, params.beginsWith]);

  return {
    directoryList,
    pageMeta,
    loading: state.loading,
    error: state.error,
  };
}
